import HeaderCalculator from "../../components/HeadrCalculator";
import Calculator from "../../components/Calculator";
import { Context } from "../../App";

export default function CalculatorPage(props) {
  const {
    canOpenCalculator,
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    userData,
  } = props;

  return (
    <>
      {canOpenCalculator ? (
        <>
          <HeaderCalculator
            statusMode={statusMode}
            setStatusMode={setStatusMode}
            isLoggedIn={isLoggedIn}
            showLogoutButton={showLogoutButton}
          />
          <Context.Provider value={{ userData }}>
            <Calculator statusMode={statusMode} isLoggedIn={isLoggedIn} />
          </Context.Provider>
        </>
      ) : (
        ""
      )}
    </>
  );
}
